import {fetch} from "utils/dataAccess";

const readJson = (url, options = {}) => fetch(url, options).then((response) => response.json());

const postJson = (url, body) => readJson(url, {method: 'POST', body: JSON.stringify(body)});

const scopedPath = (retailerId, path) => (retailerId ? `/retailers/${retailerId}${path}` : path);

export function listEnrichmentProducts(retailerId, body) {
    return postJson(scopedPath(retailerId, '/enrichment/products'), body);
}

export function getEnrichmentCounts(retailerId, body) {
    return postJson(scopedPath(retailerId, '/enrichment/counts'), body);
}

export function getEnrichmentValues() {
    return readJson('/enrichment/values');
}

export function listVariationGroups(retailerId, query) {
    return readJson(`${scopedPath(retailerId, '/variation_groups')}?${query.toString()}`);
}

export function decideEnrichmentSuggestions(action, products) {
    return postJson('/enrichment_suggestions/decisions', {action, products});
}
